import { useLocation } from "react-router-dom";
import { AtomEffect, atom, useRecoilState, useRecoilValue } from "recoil";

import {
  PatentOrderingKey,
  PatentOrderingValue,
} from "@/components/business/PatentContainer/Patent.types";

import { RECOIL_KEYS } from "./recoilKeys";

import type { ProcessStatusCode } from "@/types/code.types";

// Patent List 검색 키 (search type): allInfo/idInfo/publicationNumber/title + editor
export interface PatentListSearchFilter {
  allInfo?: string;
  idInfo?: string;
  publicationNumber?: string;
  title?: string;
  allEditorInfo?: string;
  mcEditorInfo?: string;
  ftEditorInfo?: string;
}

export interface PatentListFilter {
  search?: PatentListSearchFilter;
  pageLimit: number;
  page: number;
  patentListDataTotal: number;
  maxPage: number;
  primaryCategory: string[];
  status: ProcessStatusCode[];
  drugProfileExtractable?: boolean;
  order: Partial<Record<PatentOrderingKey, PatentOrderingValue>>;
}

const handleSearchQuery =
  (): AtomEffect<PatentListFilter> =>
  ({ setSelf, onSet }) => {
    const newSearchParams = new URLSearchParams();
    const location = useLocation();

    const filterParam = new URLSearchParams(location.search).get("filter");

    if (filterParam) {
      const { primaryCategory, status, search, drugProfileExtractable } =
        JSON.parse(filterParam);

      setSelf({
        page: 1,
        maxPage: 1,
        pageLimit: 20,
        patentListDataTotal: 0,
        primaryCategory: primaryCategory || [],
        status: status || [],
        drugProfileExtractable: drugProfileExtractable ?? false,
        order: {},
        search: search || {},
      });
    }
    onSet((newValue) => {
      if (window.location.pathname.includes("patent-list")) {
        newSearchParams.set("filter", JSON.stringify(newValue));
        window.history.pushState(
          "",
          "patent-list",
          `patent-list?${newSearchParams.toString()}`,
        );
      }
    });
  };

const patentListFilterState = atom<PatentListFilter>({
  key: RECOIL_KEYS.patentListFilterState,
  default: {
    page: 1,
    maxPage: 1,
    pageLimit: 20,
    patentListDataTotal: 0,
    primaryCategory: [],
    status: [],
    drugProfileExtractable: false,
    order: {},
    search: {},
  },
  effects: [handleSearchQuery()],
});

export const usePatentListFilterState = () =>
  useRecoilState(patentListFilterState);

export const usePatentListFilterValue = () =>
  useRecoilValue(patentListFilterState);
